exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-total[data-v-04c9f672]{z-index:1051;margin-top:3px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;padding:10px;z-index:1000;float:left;min-width:160px;list-style:none;background-color:#fff;border:1px solid #00000033;box-shadow:0 5px 10px #00000033;background-clip:padding-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04c9f672","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/forms/pedido-form.vue
// module id = 1511
// module chunks = 0